import { DEFAULT_UPPER_LIMIT } from "./constants";

// Takes in an upper limit and returns a random integer
function generateRandomNumber(threshold = DEFAULT_UPPER_LIMIT) {
  const randomInteger = Math.random();
  const scaledInteger = randomInteger * threshold;
  return Math.floor(scaledInteger);
}

export { generateRandomNumber };
